export default __webpack_public_path__ + "static/0104-3bfe58cfeb005d79584ec76a8b88a21a.png";